import { useMemo } from "react";
import { eachDayOfInterval, format, getDay, getMonth, isSameDay, isToday } from "../../../../date-fns/index.js";
import { useCalendarConfiguration } from "../CalendarRoot.js";
import { formatDate, parseDate } from "../utils.js";
function useComputeDaysByMonth(props) {
  const { months } = props;
  const { disabledDays, dateFnsOptions, highlightedDays, tooltipIntlText, firstNonArchivedDay } = useCalendarConfiguration();
  return useMemo(() => {
    const firstNonArchivedDate = firstNonArchivedDay ? parseDate(firstNonArchivedDay) : void 0;
    const daysByMonth = {};
    for (const month of months) {
      const { id: monthId, end, start, offset } = month;
      const actualMonth = getMonth(new Date(monthId));
      const dates = eachDayOfInterval({
        end,
        start
      });
      const days = dates.map((date) => {
        const label = format(date, "d", dateFnsOptions);
        const dateAsString = formatDate(date, dateFnsOptions);
        const dateIsToday = isToday(date);
        const disabled = disabledDays ? disabledDays[dateAsString] : false;
        const isHighlighted = highlightedDays ? !!highlightedDays[dateAsString] : false;
        const isFirstNonArchivedDate = !!firstNonArchivedDate && isSameDay(firstNonArchivedDate, date);
        const tooltipText = highlightedDays && isHighlighted ? tooltipIntlText?.(highlightedDays[dateAsString]) : void 0;
        const firstOfRow = getDay(date) === dateFnsOptions.weekStartsOn;
        const isAdjacentMonth = getMonth(date) !== actualMonth;
        return {
          id: dateAsString,
          date,
          type: "day",
          label,
          isToday: dateIsToday,
          disabled,
          firstOfRow,
          tooltipText,
          isHighlighted,
          isAdjacentMonth,
          isFirstNonArchivedDate
        };
      });
      const emptyDaysBefore = [];
      for (let i = 0; i < offset[0]; i++) {
        emptyDaysBefore.push({
          type: "empty",
          firstOfRow: i === 0
        });
      }
      const emptyDaysAfter = [];
      for (let i = 0; i < offset[1]; i++) {
        emptyDaysAfter.push({
          type: "empty",
          firstOfRow: false
        });
      }
      daysByMonth[monthId] = [...emptyDaysBefore, ...days, ...emptyDaysAfter];
    }
    return daysByMonth;
  }, [dateFnsOptions, disabledDays, firstNonArchivedDay, highlightedDays, months, tooltipIntlText]);
}
export {
  useComputeDaysByMonth
};
//# sourceMappingURL=useComputeDaysByMonth.js.map
